module.exports = __webpack_public_path__ + "img/svg/button-big-modal.d1ba3d635780feacbcf415ba7492755e.svg";